import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import ShipmentDetails from './ShipmentDetails';
import ShipmentsList from './ShipmentList';
import {
  rememberOverviewCollapsed,
  setOverviewCollapsed,
} from '../../../redux/slices/shipmentSlice';

const Shipments = () => {
  const dispatch = useDispatch();
  // In the store rather than in this component: the module unmounts when the user
  // goes to another one, and an overview that refolded itself on the way back would
  // be one more thing to set up again. Open unless the user folded it away — the
  // widgets are the point of the strip, so they shouldn't need unfolding first.
  const isCollapsed = useSelector((s) => s.shipments.overviewCollapsed ?? false);

  const toggleOverview = () => {
    const next = !isCollapsed;
    dispatch(setOverviewCollapsed(next));
    // Kept outside the store as well: resetReduxState() wipes that at every login,
    // and a fold the user asked for should still be there when they come back.
    rememberOverviewCollapsed(next);
  };

  return (
    <div className="flex flex-col gap-0 bg-custom-bg-purple w-full flex-1 h-full min-h-0 max-w-full">
      
      {/* Header with Chevron Toggle (same layout) */}
      <div
        className="pl-fluid-2 rounded-xl w-fit flex items-center gap-1 mt-fluid-2 cursor-pointer select-none"
        onClick={toggleOverview}
      >
        <h4 className="text-fluid-lg font-semibold text-acs-light-text dark:text-acs-dark-text transition-none">
          Shipment Overview
        </h4>

       {isCollapsed ? (
        <ChevronRight
          className="w-[18px] h-[18px] text-[#223688] dark:text-[#6DE1C2] transition-none"
        />
      ) : (
        <ChevronDown
          className="w-[18px] h-[18px] text-[#223688] dark:text-[#6DE1C2] transition-none"
        />
      )}

      </div>

      {/* Body Layout */}
      <div className="fluid-0.5 flex flex-col flex-1 min-h-0 overflow-hidden">
        
        {/* Accordion Content for ShipmentsList */}
        <div
          className={`transition-none ease-in-out overflow-hidden ${
            isCollapsed ? 'max-h-0 opacity-0' : 'max-h-[500px] opacity-100'
          }`}
        >
          <ShipmentsList isCollapsed={isCollapsed} />
        </div>

        {/* Shipment Details Section */}
        <div className="flex-1 overflow-auto">
          <ShipmentDetails />
        </div>
      </div>
    </div>
  );
};

export default Shipments;
